// URL strings only: vite.config.ts keeps these folders out of base64 inlining,
// so the bundle carries short hashed paths instead of every SVG body.
const flagUrls = import.meta.glob<string>('../assets/flags/*.svg', {
  eager: true,
  query: '?url',
  import: 'default',
});
const crestUrls = import.meta.glob<string>('../assets/crests/*.svg', {
  eager: true,
  query: '?url',
  import: 'default',
});

/** Resolved asset URLs for flags — used to style flag badges as edge-to-edge. */
const FLAG_ASSET_URLS = new Set(Object.values(flagUrls));

export function flagUrl(code: string): string | undefined {
  return flagUrls[`../assets/flags/${code}.svg`];
}

export function crestUrl(name: string): string | undefined {
  return crestUrls[`../assets/crests/${name}.svg`];
}

export function isFlagAssetUrl(url: string): boolean {
  return FLAG_ASSET_URLS.has(url);
}

const LANGUAGE_FLAG_MAP: Record<string, string> = {
  en: 'gb',
  'en-gb': 'gb',
  us: 'us',
  tr: 'tr',
  de: 'de',
  es: 'es',
  it: 'it',
  fr: 'fr',
  pt: 'pt',
  'pt-br': 'br',
  nl: 'nl',
  sv: 'se',
  no: 'no',
  pl: 'pl',
};

export function flagUrlForLanguage(language: string): string | undefined {
  const normalized = language.trim().toLowerCase();
  const short = normalized.split('-')[0] ?? normalized;
  const code = LANGUAGE_FLAG_MAP[normalized] ?? LANGUAGE_FLAG_MAP[short] ?? short;
  return flagUrl(code) ?? flagUrl('world');
}
